(jQuery)( function ( $ ) {
    // Don't close dropdown when link is clicked
    $( '.navbar-nav .menu-item-has-children a' ).on( 'click', function ( e ) {
        e.stopPropagation();
    } );
} );